/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Test_CopyInputs */

const th_meeting_test_copy = /** @type {(inputs: Meeting_Test_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คัดลอกลิงก์เชิญ`)
};

const en_meeting_test_copy = /** @type {(inputs: Meeting_Test_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy invite link`)
};

const ja_meeting_test_copy = /** @type {(inputs: Meeting_Test_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`招待リンクをコピー`)
};

const zh_meeting_test_copy = /** @type {(inputs: Meeting_Test_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制邀请链接`)
};

const es_meeting_test_copy = /** @type {(inputs: Meeting_Test_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar enlace de invitación`)
};

const pt_meeting_test_copy = /** @type {(inputs: Meeting_Test_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar link do convite`)
};

const id_meeting_test_copy = /** @type {(inputs: Meeting_Test_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salin tautan undangan`)
};

const fr_meeting_test_copy = /** @type {(inputs: Meeting_Test_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier le lien d’invitation`)
};

const tl_meeting_test_copy = /** @type {(inputs: Meeting_Test_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopyahin ang link ng paanyaya`)
};

const vi_meeting_test_copy = /** @type {(inputs: Meeting_Test_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chép liên kết mời`)
};

const ko_meeting_test_copy = /** @type {(inputs: Meeting_Test_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`초대 링크 복사`)
};

const de_meeting_test_copy = /** @type {(inputs: Meeting_Test_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einladungslink kopieren`)
};

const ru_meeting_test_copy = /** @type {(inputs: Meeting_Test_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скопировать ссылку-приглашение`)
};

const tr_meeting_test_copy = /** @type {(inputs: Meeting_Test_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Davet bağlantısını kopyala`)
};

const it_meeting_test_copy = /** @type {(inputs: Meeting_Test_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia il link d'invito`)
};

const pl_meeting_test_copy = /** @type {(inputs: Meeting_Test_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skopiuj link z zaproszeniem`)
};

const uk_meeting_test_copy = /** @type {(inputs: Meeting_Test_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скопіювати посилання-запрошення`)
};

const hi_meeting_test_copy = /** @type {(inputs: Meeting_Test_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निमंत्रण लिंक कॉपी करें`)
};

const ar_meeting_test_copy = /** @type {(inputs: Meeting_Test_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نسخ رابط الدعوة`)
};

const ms_meeting_test_copy = /** @type {(inputs: Meeting_Test_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salin pautan jemputan`)
};

const bn_meeting_test_copy = /** @type {(inputs: Meeting_Test_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আমন্ত্রণ লিঙ্ক কপি করুন`)
};

const zh_tw2_meeting_test_copy = /** @type {(inputs: Meeting_Test_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`複製邀請連結`)
};

const zh_hk2_meeting_test_copy = /** @type {(inputs: Meeting_Test_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`複製邀請連結`)
};

const ur_meeting_test_copy = /** @type {(inputs: Meeting_Test_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دعوت کا لنک نقل کریں`)
};

const fa_meeting_test_copy = /** @type {(inputs: Meeting_Test_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رونوشت پیوند دعوت`)
};

const sw_meeting_test_copy = /** @type {(inputs: Meeting_Test_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nakili kiungo cha mwaliko`)
};

const nl_meeting_test_copy = /** @type {(inputs: Meeting_Test_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uitnodigingslink kopiëren`)
};

/**
* | output |
* | --- |
* | "Copy invite link" |
*
* @param {Meeting_Test_CopyInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const meeting_test_copy = /** @type {((inputs?: Meeting_Test_CopyInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Test_CopyInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_meeting_test_copy(inputs)
	if (locale === "ja") return ja_meeting_test_copy(inputs)
	if (locale === "zh") return zh_meeting_test_copy(inputs)
	if (locale === "es") return es_meeting_test_copy(inputs)
	if (locale === "pt") return pt_meeting_test_copy(inputs)
	if (locale === "id") return id_meeting_test_copy(inputs)
	if (locale === "fr") return fr_meeting_test_copy(inputs)
	if (locale === "tl") return tl_meeting_test_copy(inputs)
	if (locale === "vi") return vi_meeting_test_copy(inputs)
	if (locale === "ko") return ko_meeting_test_copy(inputs)
	if (locale === "de") return de_meeting_test_copy(inputs)
	if (locale === "ru") return ru_meeting_test_copy(inputs)
	if (locale === "tr") return tr_meeting_test_copy(inputs)
	if (locale === "it") return it_meeting_test_copy(inputs)
	if (locale === "pl") return pl_meeting_test_copy(inputs)
	if (locale === "uk") return uk_meeting_test_copy(inputs)
	if (locale === "hi") return hi_meeting_test_copy(inputs)
	if (locale === "ar") return ar_meeting_test_copy(inputs)
	if (locale === "ms") return ms_meeting_test_copy(inputs)
	if (locale === "bn") return bn_meeting_test_copy(inputs)
	if (locale === "zh-TW") return zh_tw2_meeting_test_copy(inputs)
	if (locale === "zh-HK") return zh_hk2_meeting_test_copy(inputs)
	if (locale === "ur") return ur_meeting_test_copy(inputs)
	if (locale === "fa") return fa_meeting_test_copy(inputs)
	if (locale === "sw") return sw_meeting_test_copy(inputs)
	if (locale === "nl") return nl_meeting_test_copy(inputs)
	return en_meeting_test_copy(inputs)
});